export default class ContactTypeModel {
  id!: number;

  codigo!: number;

  descricao!: string;
}
